<template>
    <div class="dot-flashing__container">
        <div class="dot-flashing__oval"></div>
    </div>
</template>

<script>
export default {
    name: 'Loader',
    created() {}
}
</script>
